import { Box, Tooltip } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import StatusChip from '../ui/StatusChip';
import { getRejectionReason, isRejectedTemplate } from '../../utils/getRejectionReason';
import { isTemplateArchived } from '../../utils/templateArchiveUtils';

export default function TemplateStatusCell({ row }) {
  const status = row?.status ?? row?.original?.status;
  const template = row?.original ?? row;
  const rejected = isRejectedTemplate(template);
  const pending = String(status ?? '').toUpperCase() === 'PENDING';
  const reason = rejected ? getRejectionReason(template) : '';
  const archived = isTemplateArchived(template);

  if (archived) {
    return <StatusChip value="ARCHIVED" label="Archived" />;
  }

  const normalized = String(status ?? '').toUpperCase();
  const chip = (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      {normalized === 'APPROVED' ? (
        <CheckCircleOutlineIcon sx={{ fontSize: 16, color: 'success.main' }} />
      ) : null}
      <StatusChip value={status} />
    </Box>
  );

  if ((rejected || pending) && reason) {
    return (
      <Tooltip
        title={reason}
        placement="top"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: 360,
              fontSize: '0.75rem',
              lineHeight: 1.45,
            },
          },
        }}
      >
        <Box component="span" sx={{ display: 'inline-flex', cursor: 'help' }}>
          {chip}
        </Box>
      </Tooltip>
    );
  }

  return chip;
}
